import PropTypes from 'prop-types';

import {
    Avatar,
    Image
} from '@mantine/core';

import {AiOutlineAppstore} from 'react-icons/ai';
import {Application} from '../types';

export const AccountApplicationLogo = ({
                                           record,
                                           size = '70',
                                       }: {
    record: Application,
    size?: string
}) => {
    const alt = record.name;

    if (record.logoUrl) {
        return <Image src={record.logoUrl}/>
    }

    return (
        <Avatar alt={alt} size={size}>
            <AiOutlineAppstore/>
        </Avatar>
    );
};

AccountApplicationLogo.propTypes = {
    record: PropTypes.shape({
                                name: PropTypes.string,
                            }),
    size: PropTypes.number,
};

